import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShaderEffect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shader-effect, material"} maskId="square-filled-radius-0-stroke-1-IconShaderEffect"><path d="M21 21H3V20.957L20.957 3H21V21Z" fill="currentColor"/><path d="M3 19.543V13.207L13.207 3H19.543L3 19.543Z" fill="currentColor"/><path d="M3 11.793V3H11.793L3 11.793Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShaderEffect;
